
import { Toast, PullRefresh, SwipeCell, Dialog } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { collectList } from "@/req/user";
import NavBar from "@/components/navBar.vue";
import { commodityCancelCollect } from "@/req/homeIndex";
@Component({
  components: { PullRefresh, SwipeCell, NavBar },
})
export default class Logout extends Vue {
  public count = 0;
  public isLoading = false;
  public list = [
    {
      name: "角色名字七个字",
      type: "战士",
      level: "100",
      info: "耀光传奇传奇-耀光传奇耀光传奇耀光传奇耀",
      img: "",
      price: "20",
    },
  ];

  public mounted() {
    this.getList();
  }
  public onClickLeft() {
    this.$router.go(-1);
  }
  public onRefresh() {
    setTimeout(() => {
      Toast("刷新成功");
      this.isLoading = false;
      this.count++;
    }, 1000);
  }
  public async getList() {
    const obj = {
      size: "20",
      page: "1",
      type: "0",
    };
    const res = await collectList(obj);
    if (res.code == 200) {
      this.list = res.data.data;
    }
  }
  public handleDelete(item) {
    Dialog.confirm({
      title: "是否删除该收藏",
    })
      .then(() => {
        this.deleteItem(item);
      })
      .catch(() => {
        // on cancel
      });
  }
  public async deleteItem(item) {
    const obj = item;
    const res = await commodityCancelCollect({ commodity_id: item.id });
    if (res.code == 200) {
      this.getList();
    }
  }
  public toRoute(item) {
    if (item.status == -2) {
      Toast("该商品已下架");
      return false;
    }
    (this as any).$router.push({
      path: "/particulars",
      query: {
        id: item.id,
        type: item.type,
        footerStatus: false,
      },
    });
  }
}
